import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import AccommodationAmenitiesAndPoliciesContent from 'components/AccommodationKit/AccommodationAmenitiesAndPoliciesContent'
import AccommodationRoomDetailsList from 'components/AccommodationKit/AccommodationRoomDetailsList'
import { isHotelPackage } from 'lib/offer/offerTypes'

// This is stolen from `extractBedbankRoomPackageDetails` in `<AccommodationRoomTileDetails/>`. Once
// `svc-accommodation` becomes the source of truth for merchandising, we can do away with these
// hacks.
const BEDBANK_RICH_DESC_REGEX = /^\*\*/m

const AboutRoomContainer = styled(Group)`
  padding: ${rem(20)};
`

interface Props {
  pkg: App.HotelPackage | App.BedbankPackage
}

function AlwaysOnAboutRoomModalTab(props: Props) {
  const { pkg } = props

  const description = useMemo(() => {
    if (isHotelPackage(pkg)) {
      return pkg.roomType.description
    } else {
      return !BEDBANK_RICH_DESC_REGEX.test(pkg.description) ? pkg.description : undefined
    }
  }, [pkg])

  return (
    <AboutRoomContainer direction="vertical" gap={32}>
      {/* The following is based on `<AccommodationRoomTileDetails/>`. */}
      {description && <BodyText variant="medium">{description}</BodyText>}
      {/* The following is based on `<AccommodationAmenitiesAndPoliciesModal/>`. */}
      <Group direction="vertical" gap={12}>
        <Heading variant="heading4">Room Details</Heading>
        <AccommodationRoomDetailsList roomPackage={pkg} />
      </Group>
      <AccommodationAmenitiesAndPoliciesContent
        roomPackage={pkg}
        headingVariant="heading4"
        policyFontSize="medium"
      />
    </AboutRoomContainer>
  )
}

export default AlwaysOnAboutRoomModalTab
